import React from 'react'
import tenReasonHaircutBanner from "./../../../../../Images/Blog/10_Reason_HairCut/Banner.png";

const TenReasonHaircutImg = () => {
  return (
    <div className="blogImg-content">
      <img src={tenReasonHaircutBanner} alt="tenReasonHaircutBanner" loading="lazy" />
    </div>
  )
}

export default TenReasonHaircutImg
